import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import React, { FC, ReactNode, useMemo, useState } from "react";
import SwiperClass from "swiper";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import styles from "../../styles/detail/DetailDescription.module.scss";
import ButtonBack from "../common/carousel/ButtonBack";
import ButtonNext from "../common/carousel/ButtonNext";
import PackageDetailDescriptionCard from "./PackageDetailDescriptionCard";
import { ItalianExpertReadableTO } from "../../models/detail";
import Carousel from "../common/carousel/Carousel";
import { TBreackpointsCarousel } from "../../models/common/common";

const PackageDetailDescriptionCarousel: FC<{
    italiansExpert: ItalianExpertReadableTO[];
}> = ({ italiansExpert }) => {
    const [swiperClass, setSwiperClass] = useState<SwiperClass | null>(null);

    const cards: ReactNode[] = useMemo(
        () =>
            italiansExpert?.map(el => (
                // eslint-disable-next-line no-underscore-dangle
                <PackageDetailDescriptionCard key={el._id} cardData={el} />
            )) ?? [],
        [italiansExpert]
    );

    const breackPointCarousel: TBreackpointsCarousel = {
        0: {
            slidesPerView: italiansExpert.length > 1 ? 1.1 : 1,
            spaceBetween: 12,
        },
    };

    const isSM = useIsSM();

    return (
        <div className={styles.titleAndCarouselContainer}>
            <MDBContainer fluid className="px-0 pr-lg-4">
                {!isSM && italiansExpert.length > 1 && (
                    <MDBRow>
                        <MDBCol className="p-0 mb-3 d-flex justify-content-end">
                            <div className="d-flex">
                                <ButtonBack swiperClass={swiperClass} />
                                <ButtonNext
                                    className="ms-2"
                                    swiperClass={swiperClass}
                                />
                            </div>
                        </MDBCol>
                    </MDBRow>
                )}
                <MDBRow className="gx-0 pe-md-2 pe-lg-0 align-items-start">
                    <MDBCol
                        size={12}
                        md={7}
                        className={`${styles.carouselTitle} pe-lg-3`}
                        style={{ paddingTop: 0 }}
                    >
                        <h3>
                            Travel with our
                            <span className="d-block">Italian Experts!</span>
                        </h3>
                        <p className={styles.carouselSubtitle}>
                            <b>
                                Italian experts are Italians that truly love and
                                know everything about their Country.
                            </b>{" "}
                            They can&apos;t wait to share their passion and
                            knowledge with you so ... get ready and join them
                            for the best Italian trip ever!
                        </p>
                    </MDBCol>
                    {isSM && italiansExpert.length > 1 && (
                        <MDBRow>
                            <MDBCol className="p-0 mb-3 d-flex justify-content-end">
                                <div className="d-flex">
                                    <ButtonBack swiperClass={swiperClass} />
                                    <ButtonNext
                                        className="ms-2"
                                        swiperClass={swiperClass}
                                    />
                                </div>
                            </MDBCol>
                        </MDBRow>
                    )}
                    <MDBCol size={12} md={5}>
                        <Carousel
                            visibleSlides={1}
                            breakpoints={breackPointCarousel}
                            setSwiperClass={setSwiperClass}
                        >
                            {cards}
                        </Carousel>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </div>
    );
};

export default PackageDetailDescriptionCarousel;
